import React from "react";
import '../Components/About.css';
import NavHeader from '../Components/navHeader.js';
import Footer from '../Components/footer.js';
import Intro from "../Components/intro.js";

function About() {
    return(
        <>
        <NavHeader/>
        <Intro>
            <h1>Hi, I am Brian!</h1>
            <div className="BrianImage">
                <img src="/BrianTheDev.jpg" alt="Brian" height={200}/>
            </div>
        </Intro>
        <div className="HomeContent">
            
            <h1>About Me</h1>
            <h2>Hi, I'm Brian!</h2>
            <p>
                I am a Computer Science Student from <abbr title="California State University, Fullerton">CSUF</abbr>.
                I have many interests like computer programming, art, and playing video games.
            </p>
            <p>
                I have been coding for as long as I remember. I started coding in a robotics class in 7th grade. We used code.org to
                learn how to code. I especially loved the creative open ended puzzles where you can pretty much do whatever you want.
            </p>
            <p>
                My goal is to enter the software engineering field, preferrably with game development.
                Game development is my passion. I have messed around with the Unity game engine many times,
                trying all its features. For example, my most recent game is <a href="https://brianthedevguy.itch.io/rocket-joyride-1-week">RocketJoyride</a>,
                A pixel art 2D arcade game where your goal is to reach as far as possible while avoiding obstacles.
            </p>
            <h2>Contact Me!</h2>
            <p>
                I would love to hear from you! please email me at <a href="mailto:brianayala2050@gmail.com">brianayala2050@gmail.com</a> and
                I'll be more than happy to speak with you!
            </p>
        </div>
        <Footer/>
        </>
    );
}

export default About